import React from "react"
import { BaseContext } from "./base-context"

export const BackgroundBlocker: React.FC = () => {
    return <BaseContext.Consumer>
    { ({ setIsSidebarShown }) =>
        <section onClick={() => setIsSidebarShown(false)} className="w-full h-screen z-40 bg-slate-500 opacity-45 fixed top-0 left-0"></section>
    }
    </BaseContext.Consumer>
}